import React, { useMemo } from "react";
import GenericFormTab from "../shippment/tabs/GenericFormTab";
import CommonDataTable from "../../components/CommonDataTable";
import {
    cycleCountHeaderFields,
    cycleCountDetailColumns
} from "./formFields/cycleCountFields";

export default function CreateCycleCount({
    initialValues = {},
    onCancel
}) {
    /* ================= HEADER ================= */
    // const headerData = useMemo(
    //     () => initialValues?.CycleCountHeader ?? {},
    //     [initialValues]
    // );


    const headerData = useMemo(() => {
        const h = initialValues?.CycleCountHeader ?? {};

        return {
            ...h,
            createdDate: initialValues?.createdAt
                ? new Date(initialValues.createdAt).toLocaleDateString("en-GB")
                : ""
        };
    }, [initialValues]);

    /* ================= ITEMS ================= */
    const itemRows = useMemo(() => {
        const details = initialValues?.CycleCountDetail ?? [];
        return details.map((d, idx) => ({
            id: idx + 1,
            lineNo: idx + 1,

            item: d.item ?? "",
            description: d.description ?? "",
            pack: d.pack ?? "",
            uom: d.uom ?? "",
            qty_counted: d["qty counted"] ?? 0,
            system_count: d["system count"] ?? 0,
            adjusted_count: d["adjusted count"] ?? 0,
            status: d.status ?? "",
            location: d.location ?? "",
            qcRequired: "No",
            owner: d.owner ?? "",
            qty_counted: d["qty counted"] ?? 0,
            system_count: d["system count"] ?? 0,
            adjusted_count: d["adjusted count"] ?? 0,
            cost: d.cost ?? 0,
            lpn: d.lpn ?? "",
            notes: d.notes ?? "" 

        }));
    }, [initialValues]);

    return (
        <>
            {/* ================= TABS (UI ONLY) ================= */}
            <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
                <span className="text-muted">Cycle Count Header</span>
            </div>

            {/* ================= HEADER FORM ================= */}
            <div className="card mb-4 border-0 shadow-none">

                <div>
                    <GenericFormTab
                        fields={cycleCountHeaderFields}
                        formData={headerData}
                        readOnly
                    />
                </div>
            </div>


            <CommonDataTable
                id="cycle-count-items-view"
                allPossibleColumns={cycleCountDetailColumns}
                initialVisible={cycleCountDetailColumns.map(c => c.field)}
                initialRows={itemRows}
                height={380}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}

                /* 🔴 disable everything */
                checkboxSelection={false}
                enableImportButton={false}
                enableExportButton={false}
                forInventory={false}

                /* 🔒 read-only mode */
                readOnly
            />


            {/* ================= FOOTER ================= */}
            <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
            </div>
        </>
    );
}
